
const VocabTreatments = {
    'active_treatments' : ['Tratamientos activos', 'Active treatments'],
    'suspend_treatment' : ['Suspender', 'Suspend'],
    'prescription_created': ['Receta creada el: ', 'Prescription created on: '],
    'instruction_start_date': ['Fecha de inicio: ', 'Start date: '],
    'instruction_expexted_end': ['Fecha de finalizacion esperada: ', 'Expected ending date: '],
    'treatment_completed': ['Tratamiento completo', 'Treatment completed'],
    'treatment_prescribed_on': ['Fecha de prescripcion', 'Treatment prescribed on'],
  }
  export default VocabTreatments;